import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PlaceToPayPeticion } from 'src/app/models/mandatos-express/placeToPay';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Methods': '*',
    'Access-Control-Allow-Origin': '*'
  })
};

@Injectable({
  providedIn: 'root'
})
export class PlaceToPayService {

  constructor(private http: HttpClient, @Inject('env') private environment: any) { }

  urlGeneraTokenSessionPlace2pay = this.environment.urlAmbiente + '/apiTransaccionMT/generateTokenPlace2Pay';
  urlGeneraTokenSessionPlace2payExpress = this.environment.urlAmbiente + '/apiTransaccionMT/generateTokenPlace2PayExpress';
  urlGeneraTokenSessionPlace2paySusComercio = this.environment.urlAmbiente + '/apiTransaccionMT/generateTokenPlace2PaySusComercio';
  urlGetTransaction = this.environment.urlAmbiente + '/apiTransaccionMT/findTransactionPlace2Pay';


  getTokenPlace2PaySession(placeToPayEntry: PlaceToPayPeticion, isEmbebido: boolean) {
    let url = isEmbebido ? this.urlGeneraTokenSessionPlace2pay : this.urlGeneraTokenSessionPlace2payExpress;
    return this.http.post(url, placeToPayEntry, httpOptions )
  }

  getTokenPlace2PaySessionSusComercio(placeToPayEntry: PlaceToPayPeticion, isEmbebido: boolean) {
    let url = isEmbebido ? this.urlGeneraTokenSessionPlace2pay : this.urlGeneraTokenSessionPlace2paySusComercio;
    return this.http.post(url, placeToPayEntry, httpOptions )
  }

  getTransaction(placeToPayEntry: PlaceToPayPeticion) {
    return this.http.post(this.urlGetTransaction, placeToPayEntry, httpOptions )
  }

}
